module.exports = __webpack_public_path__ + "static/img/pic_3_3@2x.ca77cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/peripheralProducts/pic_3_3@2x.png
// module id = /aF4
// module chunks = 0